const InputField = ({
  label,
  name,
  type = "text",
  placeholder,
  value,
  max,
  onChange,
  required = false,
  hint,
  error,
  disabled
}) => {
  return (
    <div className="form-group">
      <label htmlFor={name}>
        {label}

        {hint && <small> ({hint})</small>}

        {required && <span> *</span>}
      </label>

      <input
        id={name}
        name={name}
        type={type}
        placeholder={placeholder}
        value={value}
        max={max}
        onChange={onChange}
        required={required}
        disabled={disabled}
        className={error ? "input-error" : ""}
      />

      {error && <small className="error-message">{error}</small>}
    </div>
  );
};

export default InputField;